import dayjs from "dayjs";

export const formatDateTime = (value) => {
  if (!value) return null;
  return dayjs(value)
    .toDate()
    .toISOString()
    .replace(/(\.\d{3})Z$/, "$1000Z");
};

export const isLifetimeTerm = (term) => {
  const months = Number(term);
  return !Number.isFinite(months) || months <= 0;
};

export const calcEndTime = (start, term) => {
  if (!start) return null;
  const months = Number(term);
  if (!Number.isFinite(months) || months <= 0) return null;
  return dayjs(start).add(months, "month");
};

/** Payload for PUT/POST of a purchase license item; lifetime terms have no EndTime. */
export const buildPurchaseItemPayload = ({
  codeNo,
  term,
  startTime,
  renewal,
}) => {
  const lifetime = isLifetimeTerm(term);
  const start = startTime ? dayjs(startTime) : dayjs();
  return {
    CodeNo: Number(codeNo),
    StartTime: formatDateTime(start),
    EndTime: formatDateTime(lifetime ? null : calcEndTime(start, term)),
    Renewal: Number(renewal) === 1 ? 1 : 0,
  };
};
